const Page404: React.FC = () => {
    return <>Page404</>
}

export default Page404
